import { createConnectTransport } from '@connectrpc/connect-web';
import {
  appVersionInterceptor,
  authorizationInterceptor,
  connectErrorInterceptor,
  permissionsInterceptor,
  sinkInterceptor,
  userAgentInterceptor,
} from '@/api/interceptors';

/**
 * ConnectRPC integration utilities for TanStack Query compatibility.
 *
 * @see {@link https://connectrpc.com/docs/web/getting-started} ConnectRPC Documentation
 * @see {@link https://tanstack.com/query/latest} TanStack Query Documentation
 */
export const transport = createConnectTransport({
  baseUrl: '/connect',
  defaultTimeoutMs: 10_000,
  interceptors: [
    sinkInterceptor,
    authorizationInterceptor,
    appVersionInterceptor,
    userAgentInterceptor,
    permissionsInterceptor,
    connectErrorInterceptor,
  ],
});

export const keepAliveTransport = createConnectTransport({
  baseUrl: '/connect',
  defaultTimeoutMs: 10_000,
  interceptors: [authorizationInterceptor, appVersionInterceptor, userAgentInterceptor, connectErrorInterceptor],
  fetch: (input, init) =>
    fetch(input, {
      ...init,
      keepalive: true, // Ensures the request can outlive the page
    }),
});
